import Alert from 'react-bootstrap/Alert';
function CommonAlert({key, variant, className, showAlert, message, style}) {
  return (
    <>
        <Alert key={key} className={className} variant={variant} showAlert={showAlert} style={style}>
          {message}
        </Alert>
    </>
  );
}

export default CommonAlert;